<template>
  <div>
    <model-table
      ref="modelTable"
      :title="compactView ? 'Blocks' : null"
      :collection="globalWidget.globalWidgetBlocks"
      :columns="columns"
      submodel
      :constructor-data="{ type: globalWidget.type }"
      orderable
      :grid="!compactView"
      :add-label="compactView ? '' : null"
      :dense="compactView"
    >
      <template #card="props">
        <div
          v-if="type === GLOBAL_WIDGET_TYPES.FOOTER"
          class="q-pa-xs"
          :class="`col-${props.row.config.width}`"
        >
          <q-card
            flat
            bordered
          >
            <q-card-section
              dense
              class="row justify-between"
              :class="compactView ? 'q-pa-xs' : ''"
            >
              <div class="col">
                <div
                  v-if="!compactView"
                  class="text-caption"
                >
                  Name
                </div>
                <div class="text-weight-bold text-capitalize">
                  {{ props.row.name }}
                </div>
              </div>
              <slot
                name="row-actions"
                v-bind="props"
              >
                <div class="col-auto">
                  <slot
                    name="prepend-row-actions"
                    v-bind="props"
                  />
                  <q-btn
                    :hover="false"
                    label="Edit"
                    dense
                    @click="$refs.modelTable.edit(props.row)"
                  />
                  <q-btn
                    :hover="false"
                    icon="more_vert"
                    round
                    dense
                    @click.stop
                  >
                    <q-menu>
                      <q-list style="min-width: 180px">
                        <q-item
                          v-close-popup
                          clickable
                          @click="$refs.modelTable.edit(props.row)"
                        >
                          <q-item-section avatar>
                            <q-icon name="edit" />
                          </q-item-section>
                          <q-item-section>
                            Edit
                          </q-item-section>
                        </q-item>
                        <q-separator />
                        <q-item
                          v-close-popup
                          clickable
                          @click="$refs.modelTable.deleteModel(props.row)"
                        >
                          <q-item-section avatar>
                            <q-icon name="delete" />
                          </q-item-section>
                          <q-item-section>
                            {{ $t('actions.remove') }}
                          </q-item-section>
                        </q-item>
                      </q-list>
                    </q-menu>
                  </q-btn>
                </div>
              </slot>
            </q-card-section>
            <q-separator />
            <q-list
              separator
            >
              <template
                v-for="col in props.cols"
                :key="col.name"
              >
                <q-item
                  v-if="!col.hideInGrid"
                  class="text-wrap"
                  :class="{ 'column': Number(props.row.width) > 3 }"
                >
                  <q-item-section>
                    <q-item-label caption>
                      {{ col.label }}
                    </q-item-label>
                  </q-item-section>
                  <q-item-section
                    class="text-wrap"
                    style="margin-left: 0px"
                  >
                    <q-item-label
                      v-if="col.component === 'chips'"
                    >
                      <q-chip
                        v-for="item in col.value"
                        :key="`${col.name}-${item}`"
                        :label="item"
                      />
                    </q-item-label>
                    <q-item-label
                      v-else
                    >
                      {{ col.value }}
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </template>
            </q-list>
          </q-card>
        </div>
      </template>
      <global-widget-block-form
        :type="type"
      />
    </model-table>
  </div>
</template>

<script>
import GlobalWidget, { GLOBAL_WIDGET_TYPES } from 'src/models/global-widget/GlobalWidget'
import { WIDTH_OPTIONS } from 'src/models/global-widget/GlobalWidgetBlock'
import ModelTable from 'src/modules/admin/components/ModelTable'
import GlobalWidgetBlockForm from 'src/modules/admin/global-widget/GlobalWidgetBlockForm'

export default {
  name: 'GlobalWidgetBlockTable',
  components: {
    ModelTable,
    GlobalWidgetBlockForm
  },
  configuration: ['currentCircuit'],
  props: {
    globalWidget: {
      type: GlobalWidget,
      required: true
    },
    compactView: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    columns () {
      if (this.type === GLOBAL_WIDGET_TYPES.FOOTER) {
        if (this.compactView) {
          return [
            { field: 'name' },
            { name: 'actions', align: 'right' }
          ]
        } else {
          return [
            { field: 'id', component: 'id', hideInGrid: true },
            { field: 'name', hideInGrid: true },
            { name: 'width', field: globalWidgetBlock => _.find(WIDTH_OPTIONS.OPTIONS, option => option.value === globalWidgetBlock.config.width)?.label },
            { name: 'displayItems', field: globalWidgetBlock => globalWidgetBlock.config.displayItems, component: 'chips' },
            { name: 'actions', align: 'right', hideInGrid: true }
          ]
        }
      } else {
        return [
          { name: 'content', field: globalWidgetBlock => globalWidgetBlock.config.header || globalWidgetBlock.config.text },
          { name: 'actions', align: 'right', hideInGrid: true }
        ]
      }
    }
  },
  created () {
    _.extend(this, {
      WIDTH_OPTIONS,
      GLOBAL_WIDGET_TYPES
    })
  }
}
</script>
